<template>
  <div v-cloak class="event-detail">
    <div v-title :data-title="detail.Name"></div>
    <!-- 中间内容 -->
    <div class="container pa-b-20 bg-fff">
      <div class="pa-t-20 pa-b-20"><Bread :list="breadList" /></div>
      <el-row type="flex" justify="space-between" class="f-wrap">
        <el-col :xs="24" :sm="14" class="">
          <div
            class="item-box"
            v-if="
              detail != null && detail.Image != null && detail.Image.length > 0
            "
          >
            <img :src="detail.Image[0]" alt="" srcset="" class="item-img" />
          </div>
        </el-col>
        <el-col :xs="24" :sm="10" class="detail01">
          <div class="font-bold fon-24 w-w-b-a">{{ detail.Name }}</div>
          <div class="flex f-end">
            <div class="flex ma-t-20">
              <div class="ma-l-20">
                <i class="iconfont icon-yanjing1"></i> {{ detail.ViewCount }}
              </div>
              <!-- <div class="ma-l-20">
                <i class="iconfont icon-zhuanfa"></i> 188
              </div> -->
              <div class="ma-l-20">
                <i class="iconfont icon-aixin"></i> {{ detail.ApplyCount }}
              </div>
            </div>
          </div>
          <div class="ma-t-10">
            <div class="ma-t-20 flex f-wrap f-center">
              时间:
              <div class="ma-l-10 width80 detail02">
                {{ detail.StartTime }} ~ {{ detail.EndTime }}
              </div>
            </div>
            <div class="ma-t-20 flex">
              地点:
              <div class="ma-l-10">{{ detail.Address }}</div>
            </div>
            <div class="flex ma-t-20 f-wrap">
              <div class="ma-t-20">购票:</div>
              <div>
                <div
                  class="c-666 b-e3 pa-10 ma-l-10 ma-t-10 cpot"
                  :class="chooseindex == index ? 'choose' : ''"
                  v-for="(item, index) in detail.Item"
                  :key="index"
                  @click="chooseindex = index"
                >
                  <span class="c-red">{{
                    item.IsFree ? '免费' : item.Price + '￥'
                  }}</span>
                  {{ item.Name }}
                </div>
              </div>
            </div>
            <div class="flex ma-t-20">
              <div class="">数量:</div>
              <div class="ma-l-10 l-h-30 nums">
                <el-input-number
                  v-model="count"
                  :min="1"
                  size="small"
                ></el-input-number>
              </div>
            </div>
          </div>
          <div class="t-center">
            <div class="flex f-around">
              <div v-if="detail.Status == '未购买'">
                <div
                  class="btn-support ma-t-40"
                  @click="btnSupport"
                  v-if="detail.ApplyStatus == 2"
                >
                  立即报名
                </div>
                <div class="btn-support ma-t-40" v-if="detail.ApplyStatus == 1">
                  未开始
                </div>
                <div class="btn-over ma-t-40" v-if="detail.ApplyStatus == 3">
                  已结束
                </div>
              </div>
              <div v-else-if="detail.Status == '已购买'">
                <div class="btn-support ma-t-40" @click="myticket">
                  我的门票
                </div>
              </div>
              <div v-else>
                <div class="btn-support ma-t-40" @click="invitenow()">
                  立即邀请
                </div>
                <p class="c-red ma-t-20">
                  您已经邀请{{ detail.ApplyEntity.GetCount }}人，继续邀请{{
                    detail.ApplyEntity.NeedCount - detail.ApplyEntity.GetCount
                  }}人即可领取门票
                </p>
              </div>
              <!-- <div class="btn-collect ma-t-40">
                <i class="iconfont icon-aixin"></i> 收藏
              </div> -->
            </div>
            <div class="flex f-center f-jcenter ma-t-80" v-if="!isWeixin">
              <div class="t-center font-bold">分享到：</div>
              <div class="flex f-jcenter width60">
                <div class="share-icon" @click="copyToClip()" title="复制链接">
                  <i class="iconfont icon-lianjie"></i>
                </div>
                <div
                  class="share-icon ma-lr-20"
                  @click="shareQQ()"
                  title="分享到QQ空间"
                >
                  <i class="iconfont icon-qqkongjian"></i>
                </div>
                <div class="share-icon" @click="shareWEB()" title="分享到微博">
                  <i class="iconfont icon-weibo"></i>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="container bg-fff">
      <div class="ma-t-30 bg-fff pa-20">
        <div>
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="活动详情" name="0"></el-tab-pane>
            <el-tab-pane label="报名人数" name="1"></el-tab-pane>
          </el-tabs>
        </div>
        <div v-if="activeName == 0">
          <div class="lh-html" v-html="detail.Detail"></div>
        </div>

        <div v-if="activeName == 1">
          <div>
            <div class="font-bold fon-16 b-b-1-e3 pa-b-20">
              报名人数{{ applyList.length }}
            </div>
            <div class="ma-t-30">
              <div
                v-for="(item, index) in applyList"
                :key="index"
                class="flex ma-b-30 f-center"
              >
                <img
                  :src="item.HeadImage"
                  alt=""
                  srcset=""
                  class="support-img width10"
                />
                <div class="width90">
                  <span class="ma-l-20 fon-16 font-bold">{{
                    item.MemberName
                  }}</span>
                </div>
              </div>
            </div>
            <div class="fy t-center">
              <el-pagination
                @current-change="handleCurrentChange"
                :hide-on-single-page="true"
                :current-page="supportPageIndex"
                :page-size="10"
                layout="prev, pager, next, jumper"
                :total="supportTotals"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="sharewx"
      width="320px"
      :show-close="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="">
        <div id="qrCode" class="qrcenter"></div>
        <p class="ptext">请使用微信扫码，分享给朋友获取门票</p>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="ticketshow"
      width="320px"
      :show-close="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="" v-for="(item, index) in detail.Ticket" :key="index">
        <div :id="'ticketCode' + index" class="qrcenter"></div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="freeitem"
      width="320px"
      :show-close="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div style="margin: 20px">
        <div class="names">
          <span>姓名：</span>
          <el-input type="text" v-model="tname"></el-input>
        </div>
        <div class="names">
          <span>手机号：</span>
          <el-input type="text" v-model="tphone"></el-input>
        </div>
        <div class="btndiv">
          <div class="btn-support ma-t-40" @click="freesave()">保存分享</div>
        </div>
      </div>
    </el-dialog>

    <div class="share" v-show="isshare" @click="isshare = false">
      <img class="width60 ma-r-20" src="../../img/share.png" />
    </div>
    <el-dialog
      :visible.sync="payview"
      width="40%"
      :show-close="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleClose"
    >
      <div>
        <div class="b-b-e pa-b-20">
          <div class="flex">
            <div class="green_tags"></div>
            <div class="fon-16 ma-l-10">购买信息</div>
          </div>
          <div class="ma-t-20 ma-lr-20 flex">
            <img :src="detail.Image[0]" class="img_204 img_cover" />
            <div class="ma-l-20 position">
              <span>
                {{ detail.Name }}-{{ detail.Item[chooseindex].Name }}</span
              >
              <div class="money flex f-between width250 f-center">
                <div>
                  <span class="fon-18 c-red"
                    >￥{{ detail.Item[chooseindex].Price * count }}</span
                  >
                </div>
                <span class="fon-18 c-0">×{{count}}</span>
              </div>
            </div>
          </div>
        </div>

        <div>
          <div class="flex ma-t-20">
            <div class="green_tags"></div>
            <div class="fon-16 ma-l-10">支付信息</div>
          </div>
          <div class="flex f-jcenter t-center ma-t-30" v-show="!weixinPay">
            <div
              class="flex flex-direction f-center ma-r-40 t-center pointer"
              @click="PayMoney('wx')"
            >
              <img src="../../img/wx.png" class="qrcode img_cover ma-b-10" />

              <div class="t-center">选择微信支付</div>
            </div>
            <!-- <div
                class="flex flex-direction f-center ma-l-40 pointer"
                @click="PayMoney('zfb')"
              >
                <img src="../img/zfb.png" class="qrcode img_cover ma-b-10" />
                <div class="t-center">选择支付宝支付</div>
              </div> -->
          </div>
          <div
            v-show="weixinPay"
            class="flex f-center f-jcenter flex-direction"
          >
            <div id="qrCode1"></div>
            <div class="flex f-center ma-t-20 fon-24">
              <img src="../../img/wx.png" class="img_40 ma-r-10" />微信支付
            </div>
          </div>

          <div class="flex ma-t-70 f-around">
            <!-- <div class="btn_green flex f-center f-jcenter">支付成功</div>
              <div
                class="btn_white flex f-center f-jcenter"
                @click="pay = false"
              >
                取消支付
              </div> -->
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
    /* 大屏 宽度大于768 */
    @media (min-width: 768px) {
        .l-h-30 {
            line-height: 30px;
        }

        .detail01 {
            padding: 20px;
        }

        .share {
            width: 100%;
            height: 100%;
            position: fixed;
            left: 0;
            right: 0;
            bottom: 0;
            top: 0;
            background-color: rgba(0, 0, 0, 0.7);
            z-index: 99;
            text-align: right;
        }

        @media (max-width: 768px) {
            .item-img {
                height: auto !important;
            }

            .detail01 {
                padding: 20px 0;
            }

            .detail02 {
                font-size: 14px;
            }
        }

        .btndiv {
            text-align: center;
            margin: 0px auto;
        }

        .ptext1 {
            text-align: center;
            margin-top: 10px;
        }

        .c-red {
            color: red;
        }

        .cpot {
            cursor: pointer;
        }

        .choose {
            border: 1px solid #fb004d;
        }

        .share-icon {
            width: 40px;
            height: 40px;
            background: #8a8a8a;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 50px;
            color: #fff;
            cursor: pointer;
        }

        .support-img {
            width: 50px;
            height: 50px;
            border-radius: 50px;
        }

        .w-w-b-a {
            word-break: break-all;
        }

        .c-red {
            color: #fb004d;
        }

        .container {
            padding-left: 30px;
            padding-right: 30px;
            box-sizing: border-box;
        }

        .item-box {
            background: #fff;

            .item-img {
                width: 100%;
                height: 520px;
            }
        }

        .btn-support {
            padding: 10px 70px;
            background: #fb004d;
            display: inline-block;
            color: #fff;
            cursor: pointer;
        }

        .btn-over {
            padding: 10px 70px;
            background: #a0a0a0;
            display: inline-block;
            color: #fff;
            cursor: pointer;
        }

        .btn-collect {
            padding: 10px 40px;
            cursor: pointer;
            border: 1px solid #a0a0a0;
            color: #a0a0a0;
        }

        .btn-support-2 {
            padding: 6px 26px;
            background: #fb004d;
            display: inline-block;
            color: #fff;
            cursor: pointer;
        }

        .qrcenter {
          text-align: center;
          width: 150px;
          margin: 0 auto;
        }
        .ptext {
          text-align: center;
          margin: 30px 0 20px 0;
          font-size: 16px;
          color: red;
        }
        .event-detail {
          .el-tabs__header {
            display: flex;
            justify-content: center;
          }
          .el-tabs__content {
            min-width: 1080px;
            margin: 0 auto;
          }
          .el-tabs__item {
            padding: 0 60px;
            font-size: 14px;
            font-family: MicrosoftYaHei;
            color: #333333;
          }
          .el-tabs__active-bar {
            height: 4px;
            font-weight: bold;
            background: #fb004d;
          }
          .is-active {
            font-size: 14px;
            font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
            font-weight: bold;
            color: #fb004d;
          }
          .el-tabs__content {
            margin-top: 45px;
          }
        }

        .nums {
          .el-input-number--small {
            .el-input-number__increase {
              height: 30px;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            .el-input-number__decrease {
              height: 30px;
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }
        }
    }
</style>
    <script>
import {
  getActivityDetail,
  getActivityApply,
  postActivityApply,
  getJsApiConfig,
  postActivityGetInvite,
  orderPay,
  PayResult
} from '../../api.js'
import Bread from '../../components/Bread.vue'
import QRCode from 'qrcodejs2'
import wx from 'weixin-js-sdk'
// studycollect
export default {
  components: { Bread },
  data() {
    return {
      id: 0,
      detail: {
        temp: 0,
        ApplyEntity: {}
      },
      breadList: [
        { name: '展映基地', path: '/event/list' },
        { name: '活动详情', path: '' }
      ],
      payview: false,
      activeName: 0,
      freeitem: false,
      ticketshow: false,
      count: 1,
      chooseindex: 0,
      eventList: [], //评论数据
      pageIndex: 1, //评论分页
      totals: 0,
      sharewx: false,
      supportList: [],
      supportTotals: 0,
      supportPageIndex: 0,
      applyList: [],
      tname: '',
      tphone: '',
      applyid: '',
      isshare: false,
      isWeixin: false,
      type: 'weixin', //支付方式
      weixinPay: false ,//是微信支付展示二维码,
      paykey:'',
      interval:'',
    }
  },
  // 其他页面进来时更新初始数据
  activated() {
    this.id = this.$route.query.id
    this.applyid = this.$route.query.applyid || ''
    //判断是否在微信浏览器里，如果在微信支付时使用微信支付，否则使用扫码支付
    var ua = navigator.userAgent.toLowerCase()
    this.isWeixin = ua.indexOf('micromessenger') != -1
    this.getList()
    this.getApplyList()

    if (this.applyid && this.applyid != '') this.getinvite()
  },
 
  methods: {
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          console.log(_)
          this.weixinPay = false
          clearInterval(this.interval)
          let a = document.getElementById('qrCode1')
          a.innerHTML = ''
          done()
        })
        .catch((_) => {
          console.log(_)
        })
    },
    //自定义分享
    setShartMesage() {
      var _this = this
      var url = ''
      if (
        this.detail.ApplyEntity.Id != '' &&
        this.detail.ApplyEntity.Id != undefined
      )
        url = '&applyid=' + this.detail.ApplyEntity.Id
      getJsApiConfig({
        url: location.href
      }).then((res) => {
        console.log(res.data.Data)
        if (res.data.Code == 0) {
          let weixin = res.data.Data
          wx.config({
            debug: false, // 开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出，仅在 pc 端时才会打印。
            appId: weixin.AppId, // 必填，公众号的唯一标识
            timestamp: weixin.Timestamp, // 必填，生成签名的时间戳
            nonceStr: weixin.NonceStr, // 必填，生成签名的随机串
            signature: weixin.Signature, // 必填，签名
            jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'] // 必填，需要使用的 JS 接口列表
          })
          wx.ready(function () {
            //需在用户可能点击分享按钮前就先调用
            wx.updateAppMessageShareData({
              title: _this.detail.Name, // 分享标题
              desc: _this.detail.Summary, // 分享描述
              link: location.origin + '/event/detail?id=' + _this.id + url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
              imgUrl: _this.detail.Image[0], // 分享图标
              success: function () {
                // 设置成功
              }
            })
            wx.updateTimelineShareData({
              title: _this.detail.Name, // 分享标题
              link: location.origin + '/event/detail?id=' + _this.id + url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
              imgUrl: _this.detail.Image[0], // 分享图标
              success: function () {
                // 设置成功
              }
            })
          })
        } else {
          this.$message({
            message: res.data.Message,
            type: 'warning'
          })
        }
      })
    },
    invitenow() {
      this.isshare = true
    },
    freesave() {
      let token = localStorage.getItem('AccessToken')
      if (!token) {
        this.$alert('您还未登录请先登录', '提示', {
          confirmButtonText: '去登录',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.$router.push('/login')
          })
          .catch(() => {})
        return
      }

      if (this.tame == '') {
        this.$message({
          message: '请填写用户的姓名',
          type: 'warning'
        })
        return
      }
      //数据验证
      if (!this.tphone) {
        this.$message({
          message: '请填写手机号',
          type: 'warning'
        })
        return
      }
      if (!/^1\d{10}$/.test(this.tphone)) {
        this.$message({
          message: '手机号格式错误',
          type: 'warning'
        })
        return
      }
      var me = [{ name: this.tname, phone: this.tphone }]
      postActivityApply({
        Id: this.id,
        ItemId: this.detail.Item[this.chooseindex].Id,
        Count: 1,
        Info: me
      }).then((res) => {
        console.log(res.data.Data)
        if (res.data.Code == 0) {
          this.freeitem = false
          this.getList()
          this.isshare = true
          this.$message({
            message: res.data.Message,
            type: 'success'
          })
        } else {
          this.$message({
            message: res.data.Message,
            type: 'warning'
          })
        }
      })
    },
    myticket() {
      this.ticketshow = true
      setTimeout(() => {
        this.detail.Ticket.forEach((item, index) => {
          document.getElementById('ticketCode' + index).innerHTML = ''
          new QRCode(document.getElementById('ticketCode' + index), {
            text: item.Code,
            width: 150,
            height: 150,
            colorDark: '#333333', //二维码颜色
            // colorLight: '#ffffff', //二维码背景色
            correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
          })
        })
      }, 500)
    },
    //复制链接
    copyToClip(message) {
      var aux = document.createElement('input')
      aux.setAttribute('value', location.href)
      document.body.appendChild(aux)
      aux.select()
      document.execCommand('copy')
      document.body.removeChild(aux)
      if (message == null) {
        alert('复制成功')
      } else {
        alert(message)
      }
    },
    //分享到qq空间
    shareQQ() {
      var query = {
        title: this.detail.Name,
        summary: this.detail.Summary,
        url: location.href,
        pics: this.detail.Cover
      }
      let url =
        'http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?' +
        this.buildUrlQuery(query)
      window.open(url)
    },
    //分享到微博
    shareWEB() {
      var query = {
        title: this.detail.Name,
        summary: this.detail.Summary,
        url: location.href,
        pics: this.detail.Cover
      }
      let url =
        'http://service.weibo.com/share/share.php?' + this.buildUrlQuery(query)
      window.open(url)
    },
    //拼接url
    buildUrlQuery(query) {
      var queryItems = []
      for (var k in query) {
        queryItems.push(k + '=' + encodeURIComponent(query[k] || ''))
      }
      return queryItems.join('&')
    },
    getinvite() {
      localStorage.setItem('cacheUrl', location.href)
      let token = localStorage.getItem('AccessToken')
      if (!token) {
        this.$alert('您还未登录请先登录', '提示', {
          confirmButtonText: '去登录',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.$router.push('/login')
          })
          .catch(() => {})
        return
      }
      postActivityGetInvite({
        ActivityId: this.id,
        ApplyId: this.applyid
      }).then((res) => {
        console.log(res.data.Data)
        if (res.data.Code == 0 && res.data.Data) {
          this.$message({
            message: '您已接受邀请',
            type: 'success'
          })
        }
      })
    },
    //支持
    btnSupport() {
      let token = localStorage.getItem('AccessToken')
      if (!token) {
        this.$alert('您还未登录请先登录', '提示', {
          confirmButtonText: '去登录',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.$router.push('/login')
          })
          .catch(() => {})
        return
      }

      var chooseItem = this.detail.Item[this.chooseindex]
      if (chooseItem.IsFree) {
        if (!this.isWeixin) {
          this.sharewx = true
          setTimeout(() => {
            document.getElementById('qrCode').innerHTML = ''
            new QRCode(document.getElementById('qrCode'), {
              text: location.href,
              width: 150,
              height: 150,
              colorDark: '#333333', //二维码颜色
              // colorLight: '#ffffff', //二维码背景色
              correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
            })
          }, 500)
          return
        } else {
          this.freeitem = true
          return
        }
      } else {
        postActivityApply({
          Id: this.id,
          ItemId: this.detail.Item[this.chooseindex].Id,
          Count: this.count
        }).then((res) => {
          console.log(res.data.Data)
          if (res.data.Code == 0) {
            this.paykey=res.data.Data.Key
            this.payview = true
          } else {
            this.$message({
              message: res.data.Message,
              type: 'warning'
            })
          }
        })
      }
    },
     //支付方式
     PayMoney(e) {
      var _this=this;
                let token = localStorage.getItem('AccessToken') || ''
                this.type = 'weixin'
                if (e == 'zfb') {
                    this.type = 'alipay'
                }
                let data = {
                    Key: this.paykey,
                    Type: this.type,
                    Token: token
                }
                orderPay(data).then((res) => {
                    console.log(res)
                    if (res.data.Code == 0) {
                        if (this.type == 'weixin') {
                            this.weixinPay = true
                            _this.interval = setInterval(() => {
                                _this.getPayState(res.data.Data.PayId)
                            }, 1000 * 2)
                            new QRCode(document.getElementById('qrCode1'), {
                                text: res.data.Data.Qrcode,
                                width: 150,
                                height: 150,
                                colorDark: '#333333', //二维码颜色
                                // colorLight: '#ffffff', //二维码背景色
                                correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
                            })
                        } 
                    }
                })
            },
    getPayState(e) {
      var _this = this
      let token = localStorage.getItem('AccessToken') || ''
      PayResult({ PayId: e, Token: token })
        .then((result) => {
          if (result.data.Data) {
            _this.$message.success('支付成功')
            clearInterval(_this.interval)
            setTimeout(() => {
              //  _this.loadingInstance1.close();
              location.reload()
            }, 1500)
          }
        })
        .catch(() => {})
    },
    //tabs切换
    handleClick(e) {
      console.log(e.index)
    },
    //获取进度
    getProgress(item) {
      return ((item.GetAmount * 100) / item.Amount).toFixed(2) + '%'
    },
    //获取剩余时间
    getSurplus(endTime) {
      let nowTime = new Date()
      endTime = new Date(endTime)
      let sub = endTime - nowTime
      return Math.trunc(sub / (1000 * 60 * 60 * 24))
    },
    getList() {
      // let token = localStorage.getItem("AccessToken");
      // console.log(data);
      getActivityDetail({
        id: this.id
      }).then((res) => {
        if (res.data.Code == 0) {
          //var list=res.data.Data;
          //list.Item=list.Item.sort(function(a,b){return b.Price-a.Price});
          //console.log("list",list);
          this.detail = res.data.Data
          document.title = this.detail.Name
          this.setShartMesage()
        }
      })
    },
    getApplyList() {
      // let token = localStorage.getItem("AccessToken");
      // console.log(data);
      getActivityApply({
        id: this.id
      }).then((res) => {
        if (res.data.Code == 0) {
          this.applyList = res.data.Data.List
        }
      })
    },
    // 当前页改变时触发
    handleCurrentChange(e) {
      this.supportPageIndex = e
    }
  }
}
</script>
    